import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '分类浏览', path: '/category/all' },
    { name: '材质选购', path: '/category/cailiao' },
    { name: '款式推荐', path: '/category/kuanshi' },
    { name: '尺码指南', path: '/category/chima' },
  ],
  categories: [
    { name: '品牌推荐', path: '/category/pinpai' },
    { name: '场景选购', path: '/category/changjing' },
    { name: '关于我们', path: '/about' },
  ],
  articles: [
    { name: '内裤材质终极对比', path: '/article/fabric-comparison-guide' },
    { name: '尺码测量指南', path: '/article/size-measurement-guide' },
    { name: '2026年TOP10推荐', path: '/article/2026-top-10-recommendations' },
    { name: '夏季透气内裤推荐', path: '/article/summer-breathable-guide' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-200/50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-primary-500">
                内裤精选指南
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-xs">
              专注女性内裤选购指南，提供最专业的材质分析、款式推荐与品牌评测，帮助每位女性找到最适合自己的内裤。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              更多内容
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.articles.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} 内裤精选指南. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="text-foreground-400 hover:text-primary-500 transition-colors duration-200"
                aria-label="隐私政策"
              >
                <span className="text-xs">隐私政策</span>
              </a>
              <a
                href="#"
                className="text-foreground-400 hover:text-primary-500 transition-colors duration-200"
                aria-label="使用条款"
              >
                <span className="text-xs">使用条款</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}